import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useResolvedPath, useMatch, NavLink, useLocation, matchPath } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getMenuInfo } from '../../reducers/selectors/selectors.jsx';

function NavItem({ menu, isMobile, isVisible, ...props }) {
	const { t }   = useTranslation();
	let resolved  = useResolvedPath(menu.url);
	let match     = useMatch({ path: resolved.pathname });
	let location  = useLocation();
	let match2    = matchPath({path: resolved.pathname, end: false, },location.pathname);
	
	let icon      = menu.icon && <div className="menu-icon"><i className={menu.icon}></i></div>;
	let img       = menu.img && <div className="menu-icon-img"><img src={menu.img} alt="" /></div>;
	let caret     = (menu.childMenuList && !menu.badge) && <div className="menu-caret"></div>;
	let label     = menu.label && <span className="menu-label ms-5px">{menu.label}</span>;
	let badge     = menu.badge && <div className="menu-badge">{menu.badge}</div>;
	let highlight = menu.highlight && <i className="fa fa-paper-plane text-theme"></i>;
	let title     = menu.menuName && <div className="menu-text">{t(`MENU_I18N.${menu.menuName}`, { defaultValue: menu.menuName })} {label} {highlight}</div>;

	const handleClick = (e) => {
		if (menu.childMenuList && menu.childMenuList.length > 0) {
			// 자식 메뉴가 있을 때만 preventDefault 호출
			e.preventDefault();
		}
	};

	return (
		<div className={'menu-item' + ((match || match2) ? ' active' : '') + (menu.childMenuList ? ' has-sub' : '')} style={{ display: isVisible ? 'block' : 'none' }}>
			<NavLink className="menu-link" to={menu.url} {...props} onClick={handleClick} >
				{ img } { icon } { title }{ caret } { badge }
			</NavLink>

			{menu.childMenuList && (
				<div className="menu-submenu">
					{isMobile && menu.menu_id === 'menu1' ? (
						menu.childMenuList
							.filter(submenu => submenu.menu_id === 'menu1-1')
							.map((submenu, i) => (
								<NavItem key={i} menu={submenu} isMobile={isMobile} isVisible={isVisible} />
							))
					) : (
						menu.childMenuList.map((submenu, i) => (
							<NavItem key={i} menu={submenu} isMobile={isMobile} isVisible={isVisible} />
						))
					)}
				</div>
			)}
		</div>
	);
}

const SidebarNav = () => {
	const { t, i18n }             = useTranslation();
	const [isMobile, setIsMobile] = useState(false);

	const menuInfo                = useSelector(state => getMenuInfo(state) || []);

	const menus = useMemo(() => {
		return menuInfo;
	}, [menuInfo]);

	useEffect(() => {
		const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // 예시: 768px 이하로 모바일로 간주
        };

        window.addEventListener('resize', handleResize);
        handleResize(); // 초기 로드 시에도 체크

        return () => {
            window.removeEventListener('resize', handleResize);
        };
	}, [i18n.language, t]);

	return (
		<div className="menu">
			<div className="menu-header">Navigation</div>
			{menus.map((menu, i) => (
				<NavItem key={i} menu={menu} isMobile={isMobile} isVisible={!isMobile || (isMobile && (menu.menu_id === 'menu1' || menu.menu_id === 'menu3'))} />
			))}
		</div>
	);
};

export default SidebarNav;